<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <h5 class="content-header-title float-left pr-1 mb-0">
              {{ issue.title }}
            </h5>
            <div class="breadcrumb-wrapper col-12">
              <ol class="breadcrumb p-0 mb-0">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'DashboardPage' }">
                    <em class="bx bx-home-alt"></em>
                  </router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'IssuesPage' }">{{$t('Issues')}}</router-link>
                </li>
                <li class="breadcrumb-item active">{{ issue.title }}</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-body">
        <div class="row match-height">
            <div class="col-12">
              <div class="text-right">
                <router-link :to="{ name: 'IssuesPage' }">
                  <button class="btn btn-secondary mb-1">
                    Go back to list
                  </button>
                </router-link>
              </div>
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <h2>{{ issue.title }}</h2>
                                    <small style="white-space: nowrap;" v-if="issue.createdAt">
                                        {{$t('Created on')}} {{ issue.createdAt.split("T")[0] }} - {{$t('Contract ID')}}: {{ issue.contractId }}
                                    </small>
                                    <br />
                                    {{$t('Urgency')}}:
                                    <div class="badge badge-danger mr-1 mb-1 mt-1" v-if="issue.urgent === true">{{$t('High Urgency')}}</div>
                                    <div class="badge badge-warning mr-1 mb-1 mt-1" v-if="issue.urgent === false">{{$t('Low Urgency')}}</div>

                                    <span>{{$t('Status')}}: </span>
                                    <div class="badge badge-danger mr-1 mb-1 mt-1" v-if="issue.status === 'open'">{{$t('Open')}}</div>
                                    <div class="badge badge-success mr-1 mb-1 mt-1" v-if="issue.status === 'resolved'">{{$t('Resolved')}}</div>
                                </div>

                                <div class="col-12 mt-3">
                                    <div class="chat-container" v-if="issue.messages && issue.messages.length" @mouseover="tooltip()">
                                        <div class="chat-content">
                                            <div class="chat" v-for="(message, index) in issue.messages" :key="index" :class="(message.createdByUser.type === 'landlord' || message.createdByUser.type === 'superadmin') ? 'chat-left' : ''">
                                                <div class="chat-avatar">
                                                    <div class="avatar m-0 p-25" style="background: #FF8302;" data-toggle="tooltip" data-placement="top" :title="(message.createdByUser.name) ? `${message.createdByUser.name} (${capitalize(message.createdByUser.type)})` : `${capitalize(message.createdByUser.type)}`">
                                                        <div class="avatar-content">
                                                            <span class="font-medium-1 text-white" v-if="message.createdByUser.type === 'tenant'">T</span>
                                                            <span class="font-medium-1 text-white" v-if="message.createdByUser.type === 'landlord'">L</span>
                                                            <span class="font-medium-1 text-white" v-if="message.createdByUser.type === 'superadmin'">S</span>
                                                            <span class="font-medium-1 text-white" v-if="message.createdByUser.type === 'admin'">A</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="chat-body">
                                                    <div class="chat-message">
                                                        <p>{{ message.text }}</p>
                                                        <span class="chat-time">
                                                            {{ message.createdAt.split("T")[0] }} at {{ message.createdAt.split("T")[1].substring(0, 5) }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/app-assets/js/get-countries.js";
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import Alert from "@/components/Alerts";

export default {
  data() {
    return {
      issue: {},
      issueUUID: this.$route.params.uuid,
    };
  },

  methods: {
    getIssue() {
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });

      this.$apiCall
        .get(`/v1/issues/${this.issueUUID}`)
        .then((response) => {
          $.unblockUI();
          this.issue = response.data;
          this.issue.messages = (this.issue.messages && this.issue.messages.length) ? this.issue.messages.reverse() : this.issue.messages;
        })
        .catch((error) => {
          $.unblockUI();
          console.log(error);
        });
    },

    tooltip(){
        $(".avatar").tooltip();
    },

    capitalize(string) {
        return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
    }
  },

  mounted() {
    this.getIssue();
  },
};
</script>

<style scoped>
    .chat .chat-avatar{
        float: right;
    }

    .chat.chat-left .chat-avatar{
        float: left;
    }

    .chat .chat-body{
        overflow: hidden;
        margin: .67rem 2rem 0 0;
    }

    .chat .chat-message{
        position: relative;
        float: right;
        text-align: right;
        padding: .75rem 1rem;
        margin: 0 1.33rem 1.33rem .3rem;
        clear: both;
        word-break: break-word;
        color: #FFF;
        background: #5A8DEE;
        border-radius: .267rem;
        box-shadow: 0 2px 4px 0 rgba(90,141,238,.6);
    }

    .chat.chat-left .chat-message{
        text-align: left;
        float: left;
        margin: 0 .3rem 1.8rem 1.3rem;
        color: #727E8C;
        background-color: #FAFBFB;
        box-shadow: 0 2px 6px 0 rgba(0,0,0,.3);
    }

    .chat-message p{
        margin-bottom: 0;
    }

    .chat .chat-time{
        position: absolute;
        bottom: -20px;
        right: 0;
        color: #828D99;
        font-size: .8rem;
        white-space: nowrap;
    }
</style>